import script from "./FtrAppGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./FtrAppGuide.vue?vue&type=script&setup=true&lang=js"

import "./FtrAppGuide.vue?vue&type=style&index=0&id=42c444a3&lang=css"

const __exports__ = script;

export default __exports__